export enum SourceOfFundIdsEnum {
    AlaricAtHomeTrading = 1,
    AlaricSalary,
    AlaricInheritance,
    AlaricFamilyMember,
    AlaricPensionBenefitProgram,
    AlaricInvestmentsAndSavings,
    AlaricSelfEmployment,
    AlaricLoan,
    FLBAtHomeTrading,
    FLBEmploymentOrSelfEmploymer,
    FLBInheritance,
    FLBParentalAllowance,
    FLBPartnerIncome,
    FLBPensionOrGovernmentBenefits,
    FLBSavingsAndInvestments,
    FLBTrustFunds,
    Alaric10nSalary,
    Alaric10nSelfEmployment,
    Alaric10nAtHomeTrading,
    Alaric10nFamilyMember,
    Alaric10nInheritance,
    Alaric10nInvestmentsAndSavings,
    Alaric10nPensionBenefitProgram,
    Alaric10nLoan,
}
